import { render, staticRenderFns } from "./page-inspiration-details.vue?vue&type=template&id=181c6f40"
import script from "./page-inspiration-details.js?vue&type=script&lang=js&external"
export * from "./page-inspiration-details.js?vue&type=script&lang=js&external"
import style0 from "./page-inspiration-details.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports